const comps = import.meta.glob("../../components/**/*.vue");

/**
 * This will lazy load a component
 *
 * @param {String} view The file path of the component
 * @returns Asynchronous component
 */
export default function (view) {
  return comps[`../../components/${view}.vue`];
}
